import { render, staticRenderFns } from "./ToReview.vue?vue&type=template&id=15a654b9&scoped=true&"
import script from "./ToReview.vue?vue&type=script&lang=ts&"
export * from "./ToReview.vue?vue&type=script&lang=ts&"
import style0 from "./ToReview.vue?vue&type=style&index=0&id=15a654b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a654b9",
  null
  
)

export default component.exports